import { EntityDefinition } from '@/types/crud';

export const abacUserAttributeEntity: EntityDefinition = {
  name: 'abacUserAttribute',
  displayName: 'User Attributes',
  apiEndpoint: '/abac/custom-attributes',
  idField: 'id',
  nameField: 'attribute_name',
  copyable: false,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'abac.fieldLabels.id',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'attribute_name',
      label: 'abac.fieldLabels.attributeName',
      type: 'text',
      required: true,
      placeholder: 'abac.fieldPlaceholders.enterAttributeName',
      order: 1
    },
    {
      key: 'attribute_type',
      label: 'abac.fieldLabels.attributeType',
      type: 'select',
      required: true,
      options: [
        { value: 'USER', label: 'abac.attributeTypes.user' }
      ],
      defaultValue: 'USER',
      hidden: true,
      order: 2
    },
    {
      key: 'data_type',
      label: 'abac.fieldLabels.dataType',
      type: 'select',
      required: true,
      options: [
        { value: 'STRING', label: 'abac.dataTypes.string' },
        { value: 'NUMBER', label: 'abac.dataTypes.number' },
        { value: 'BOOLEAN', label: 'abac.dataTypes.boolean' },
        { value: 'DATE', label: 'abac.dataTypes.date' },
        { value: 'TIME', label: 'abac.dataTypes.time' },
        { value: 'JSON', label: 'abac.dataTypes.json' }
      ],
      defaultValue: 'STRING',
      order: 3
    },
    {
      key: 'description',
      label: 'abac.fieldLabels.description',
      type: 'textarea',
      placeholder: 'abac.fieldPlaceholders.enterDescription',
      order: 4
    },
    {
      key: 'is_active',
      label: 'abac.fieldLabels.active',
      type: 'boolean',
      defaultValue: true,
      order: 5
    },
    {
      key: 'created_by_email',
      label: 'abac.fieldLabels.createdBy',
      type: 'text',
      readOnly: true,
      formHidden: true,
      order: 6
    },
    {
      key: 'created_at',
      label: 'abac.fieldLabels.created',
      type: 'datetime',
      order: 7
    }
  ]
};
